// extracted by mini-css-extract-plugin
export var borderRadius = "_5u-4";
export var large = "_5u-3";
export var logoContainer = "_5u-0";
export var nameLogo = "_5u-2";
export var small = "_5u-1";